import { Code, Text } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import GraphqlError from '@components/graphql-error';
import LoadingData from '@components/graphql-loading-data';

import { GET_ITINERARY_VERSIONS } from '@queries/itinerary-versions';

function ItineraryVersions() {
  const { tripProfileId } = useParams();
  // const tripProfileId = '2803d03e-0868-46d9-b37b-b06eddbb10d7';

  const { loading, error, data } = useQuery(GET_ITINERARY_VERSIONS, {
    variables: {
      tripProfileId: tripProfileId || '',
    },
  });
  if (loading) return <LoadingData />;
  if (error) return <GraphqlError error={error} />;
  if (!tripProfileId) return <Text>Use /admin/itinerary-versions/tripProfileId </Text>;

  return <div>{data && <Code block>{JSON.stringify(data, null, 2)}</Code>}</div>;
}

export default ItineraryVersions;
